import { useCallback } from 'react';
import { useHrpsApi } from '../clients/useHrpsApi';
import { useTranslation } from '../components/blocks';
import { usePageMessaging } from '../components/composites';

/**
 * Opens a sales order document. Download URLs expire, so a fresh one is requested on every download
 * rather than reusing the one the document list was loaded with.
 */
export const useDownloadSalesOrderDocument = () => {
    const {
        returnOrders: { getSalesOrderDocumentUrl },
    } = useHrpsApi();
    const { showError } = usePageMessaging();
    const { t } = useTranslation('common');

    return useCallback(
        async (resellerId: string, purchaseOrderId: string, documentId: string) => {
            try {
                const documentUrl = await getSalesOrderDocumentUrl(resellerId, purchaseOrderId, documentId);
                window.open(documentUrl, '_blank', 'noreferrer');
            } catch (error) {
                showError(t('failedToDownloadDocument-error'));
            }
        },
        [getSalesOrderDocumentUrl, showError, t]
    );
};
